import { LockerType } from '@/types/LockerType'
import { List, MoreVertical, Trash2 } from 'lucide-react'
import { Dropdown } from 'react-bootstrap'

type LockerMenuType = {
    locker: LockerType
    handleDelete: (locker: LockerType) => void
}

export default function LockerMenu ({lockerMenuProps}: {lockerMenuProps: LockerMenuType}) {
    const {locker, handleDelete} = lockerMenuProps

    return (
      <Dropdown>
        <Dropdown.Toggle as='div' className='no-arrow'>
          <MoreVertical size={20} />
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <Dropdown.Item href={'/lockers/detail/' + locker?.id}  className='d-none d-md-block'>
              <List size={16} /> Détail
          </Dropdown.Item>
          <Dropdown.Item
            onClick={() => handleDelete(locker)}
            className='d-flex align-items-center gap-2 py-2'
          >
            <Trash2 size={16} /> Supprimer
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    )
}